export default __webpack_public_path__ + "static/easyLife365_Tipster-a6a45fc9b7008261a8bdaae86ca070e6.svg";